<template>
  <a id="a-logo" data-transition="logo" data-cta>
    <svg viewBox="0 0 177 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.578 17.3459L10.935 13.075H4.55103L2.90802 17.3459H0L6.90002 0H8.66003L15.491 17.3459H12.578ZM7.76599 4.29492L5.41901 10.5869H10.113L7.76599 4.29492Z" fill="#212222"/>
      <path d="M27.251 17.346V5.82924e-05H33.8C34.897 -0.0601661 35.9941 0.118521 37.0153 0.52374C38.0366 0.928959 38.9577 1.55097 39.715 2.34698C41.2385 4.10483 42.0211 6.3851 41.898 8.70807C42.0175 11.0241 41.2163 13.2935 39.669 15.0211C38.875 15.8129 37.9235 16.4289 36.876 16.8293C35.8286 17.2296 34.7087 17.4054 33.589 17.345L27.251 17.346ZM29.951 14.7651H33.706C34.4514 14.8057 35.196 14.672 35.8807 14.3744C36.5653 14.0769 37.1711 13.6237 37.65 13.051C38.6413 11.7991 39.1493 10.2324 39.081 8.63702C39.1455 7.06416 38.637 5.52128 37.65 4.29498C37.1745 3.72465 36.5727 3.27298 35.8923 2.97564C35.2119 2.67831 34.4715 2.54347 33.73 2.58197H29.951V14.7651Z" fill="#212222"/>
      <path d="M57.0641 2.62891H51.9951V0H64.8821V2.62891H59.8112V17.3469H57.0641V2.62891Z" fill="#212222"/>
      <path d="M76.7148 17.3459V0H87.7938V2.55798H79.4138V7.27698H87.1838V9.83496H79.4138V14.788H87.8138V17.3459H76.7148Z" fill="#212222"/>
      <path d="M100.612 17.3459V0H103.312V14.741H112.466V17.3459H100.612Z" fill="#212222"/>
      <path d="M126.999 0H124.299V17.346H126.999V0Z" fill="#212222"/>
      <path d="M140.615 17.3459V0H151.694V2.55798H143.314V7.27698H151.084V9.83496H143.314V14.788H151.714V17.3459H140.615Z" fill="#212222"/>
      <path d="M173.742 17.346L169.516 10.537H167.216V17.346H164.516V1.29202e-05H170.642C171.404 -0.050597 172.169 0.0612303 172.885 0.32826C173.602 0.59529 174.253 1.01139 174.797 1.54896C175.752 2.55403 176.275 3.89435 176.252 5.28102C176.272 6.43084 175.899 7.55302 175.195 8.46217C174.49 9.37132 173.497 10.013 172.379 10.281L177.004 17.346H173.742ZM167.217 2.558V8.02699H170.217C172.4 8.02699 173.456 6.827 173.456 5.261C173.47 4.89249 173.406 4.52507 173.268 4.18312C173.13 3.84116 172.921 3.53242 172.655 3.27723C172.388 3.02205 172.071 2.82624 171.723 2.70277C171.376 2.5793 171.006 2.53094 170.639 2.56093L167.217 2.558Z" fill="#212222"/>
    </svg>
  </a>
</template>

<script>
import { app } from '@/utils/store';

import Logo from './logo';

let logo;

export default {
  data() {
    return {
      lang: app.language,
    };
  },
  mounted() {
    logo = new Logo();
    logo.init();
  },
};
</script>
